import React from "react";
import { formateDateWithTime } from "../../../utils/commonFunctions";
import { AUTOMATION_MAIL_HISTORY } from "../../../constant/tableHeadersConstants/LeadDirectoryConstants/leadDirectoryListTableHeaders";
import {
  AutomatedEmailType,
  EmailType,
} from "../../../commonTypes/clientDirectoryTypes";

type AppProps = {
  data: AutomatedEmailType;
};

const AutoMatedMailData = ({ data }: AppProps) => {
  return (
    <>
      {data?.map((item: EmailType) => {
        return (
          <tr>
            {AUTOMATION_MAIL_HISTORY?.map((singleHeader: any) => {
              if (singleHeader?.value === "email_name") {
                return <td>{item?.email_name}</td>;
              } else if (singleHeader?.value === "subject") {
                return <td>{item?.subject}</td>;
              } else if (singleHeader?.value === "sent_at") {
                return <td>{formateDateWithTime(item?.sent_at)}</td>;
              }
            })}
          </tr>
        );
      })}
    </>
  );
};

export default AutoMatedMailData;
